import get from 'lodash.get';

const getTosURL = (rootState) => get(rootState, 'partner.properties.tosUrl', null);

export default getTosURL;
